import { CoreUiException } from "./core-ui-exception";

/**
 * Thrown when the server returns a 400 Bad Request response.
 * Indicates the request was malformed or contained invalid data.
 */
export class BadRequestException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("BadRequestException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, BadRequestException.prototype);
    }
}
